import { useEffect, useState } from 'react'

const useSizeColor = ( sizeColorInit ) => {

    const [ colors, setColors ] = useState(null)
    const [ sizes, setSizes ] = useState(null)
    const [ selectColor, setSelectColor ] = useState(null)
    const [ selectSize, setSelectSize ] = useState(null)
    const [ selectedSizeColros, setSelectedSizeColros ] = useState(null)


    useEffect(()=>{
        if(sizeColorInit){
            const listColors = sizeColorInit?.map(colores => colores?.color)

            if(listColors?.length > 1){
                setColors(listColors)
            }else{
                setColors(listColors)
                setSelectColor(listColors[0])
            }
        }
    },[sizeColorInit])
    
    useEffect(()=>{
        if(selectColor){
            const listSizes = sizeColorInit.filter(colores => colores?.color === selectColor)
            setSelectedSizeColros(null)
            if(listSizes[0]?.sizes?.length > 1){
                setSizes(listSizes[0]?.sizes)
            }else{
                setSizes(listSizes[0]?.sizes)
                setSelectSize({sku: listSizes[0]?.sizes[0]?.sku, id: listSizes[0]?.sizes[0]?.id})
            }
        }
    },[selectColor])

    useEffect(()=>{
        if(selectSize){
            if(selectSize?.sku && selectSize?.id){
                setSelectedSizeColros(
                    {
                        children_sku: selectSize?.sku,
                        variant_id: selectSize?.id
                    }
                )
            }
            else{
                setSelectedSizeColros(null)
            }
        }
    },[selectSize])

    // useEffect(()=>{
    //     if(selectedSizeColros){
    //         console.log('selectedSizeColros: ',selectedSizeColros)
    //     }
    //     else{
    //         console.log('selectedSizeColros: ',selectedSizeColros)
    //     }
    // },[selectedSizeColros, selectColor])

    return {
        colors,
        sizes,
        selectedSizeColros,
        setSelectColor,
        setSelectSize
    }
}

export default useSizeColor